import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    setError("");
    setLoading(true);

    try {
      await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      navigate("/admin");
    } catch (error) {
      console.error(error);

      setError("البريد الإلكتروني أو كلمة المرور غير صحيحة.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">

      <div className="admin-login-card">

        {/* LOGO */}

        <div className="admin-logo">
          M
        </div>

        <div className="admin-brand">
          <span>MADAD</span>
          <h1>مداد</h1>
        </div>

        {/* TITLE */}

        <div className="admin-login-header">
          <p>لوحة التحكم</p>

          <h2>
            تسجيل دخول الإدارة
          </h2>

          <span>
            سجّلي الدخول لإدارة محتوى مركز مداد
          </span>
        </div>

        {/* FORM */}

        <form onSubmit={handleLogin}>

          <div className="admin-field">

            <label>
              البريد الإلكتروني
            </label>

            <input
              type="email"
              placeholder="admin@madad.com"
              value={email}
              onChange={(e) =>
                setEmail(e.target.value)
              }
              required
            />

          </div>


          <div className="admin-field">

            <label>
              كلمة المرور
            </label>

            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) =>
                setPassword(e.target.value)
              }
              required
            />

          </div>


          {error && (
            <div className="admin-error">
              {error}
            </div>
          )}


          <button
            type="submit"
            className="admin-login-button"
            disabled={loading}
          >
            {loading
              ? "جاري تسجيل الدخول..."
              : "تسجيل الدخول"}
          </button>

        </form>


        <div className="admin-login-footer">
          <span>Madad Education & Training Center</span>
        </div>

      </div>

    </div>
  );
}

export default AdminLogin;